export const quotesInterestRoutes = {
  shortInterest: { proxy: 'quotes/short-interest', upstream: 'rest/v1/shortinterest' },
} as const;
